<template lang="pug">
el-drawer(
  title="編輯館別"
  :visible.sync="drawer"
  direction="rtl"
  :before-close="handleClose")
  .drawer.flex.column.gap-20
    .data.flex.column.gap-6
      .title 館別名稱
      .input.flex.align-center.justify-stretch
        el-input.input(disabled, v-model="name")
    .data.flex.column.gap-6
      .title 負責人
      .input.flex.align-center.justify-stretch
        el-input.input(v-model="chargePerson", placeholder="請輸入負責人")
    .data.flex.column.gap-6
      .title Logo
      .photo.flex.column.align-start.gap-10
        el-button(type="primary", size="mini", @click="uploadLogo") 點此上傳
        input(
          accept="image/*",
          type="file", ref="uploadLogo",
          @input="changeLogoFile")
        .preview.flex.align-end.gap-10(v-if="logoPreview !== ''")
          img.logo(:src="logoPreview")
          .remove-icon.flex.align-center.justify-center.clickable(@click="removeLogo")
            i.el-icon-close
    .data.flex.column.gap-6
      .title 統編章
      .photo.flex.column.align-start.gap-10
        el-button(type="primary", size="mini", @click="uploadSeal") 點此上傳
        input(
          accept="image/*",
          type="file", ref="uploadSeal",
          @input="changeSealFile")
        .preview.flex.align-end.gap-10(v-if="sealPreview !== ''")
          img.seal(:src="sealPreview")
          .remove-icon.flex.align-center.justify-center.clickable(@click="removeSeal")
            i.el-icon-close
    .data.flex.column.gap-6
      .title 印花稅總繳章
      .photo.flex.column.align-start.gap-10
        el-button(type="primary", size="mini", @click="uploadStamp") 點此上傳
        input(
          accept="image/*",
          type="file", ref="uploadStamp",
          @input="changeStampFile")
        .preview.flex.align-end.gap-10(v-if="stampPreview !== ''")
          img.seal(:src="stampPreview")
          .remove-icon.flex.align-center.justify-center.clickable(@click="removeStamp")
            i.el-icon-close
    .data.flex.column.gap-6
      .title 位置圖
      .photo.flex.column.align-start.gap-10
        el-button(type="primary", size="mini", @click="uploadPosition") 點此上傳
        input(
          accept="image/*",
          type="file", ref="uploadPosition",
          @input="changePositionFile")
        .preview.flex.align-end.gap-10(v-if="positionPreview !== ''")
          img.position(:src="positionPreview")
          .remove-icon.flex.align-center.justify-center.clickable(@click="removePosition")
            i.el-icon-close
    .op.flex.align-center-justify-stretch.gap-10
      el-button.button(@click="cancel") 取消
      el-button.button(@click="updateBranch", type="primary") 設定
</template>

<script>
import {
  updateBranchCustom,
  createLogo,
  createSeal,
  createPosition,
  createStamp,
} from '@/api/place';

export default {
  name: 'place-edit',
  data() {
    return {
      drawer: false,

      origData: undefined,
      name: '',
      chargePerson: '',
      logoID: '',
      logoFile: undefined,
      logoPreview: '',
      sealID: '',
      sealFile: undefined,
      sealPreview: '',
      stampID: '',
      stampFile: undefined,
      stampPreview: '',
      positionID: '',
      positionFile: undefined,
      positionPreview: '',
    };
  },
  methods: {
    uploadPosition() {
      this.$refs.uploadPosition.click();
    },
    async changePositionFile() {
      if (this.$refs.uploadPosition.files.length < 1) {
        return;
      }
      this.$execWithLoading(async () => {
        const file = this.$refs.uploadPosition.files[0];
        const rsp = await createPosition(file);
        this.positionID = rsp.id;
        this.positionFile = file;
        this.positionPreview = URL.createObjectURL(file);
      }, (e) => this.$showAxiosException('上傳位置圖失敗', e));
    },
    removePosition() {
      this.positionFile = undefined;
      this.positionPreview = '';
      this.positionID = '';
    },
    uploadStamp() {
      this.$refs.uploadStamp.click();
    },
    async changeStampFile() {
      if (this.$refs.uploadStamp.files.length < 1) {
        return;
      }
      this.$execWithLoading(async () => {
        const file = this.$refs.uploadStamp.files[0];
        const rsp = await createStamp(file);
        this.stampID = rsp.id;
        this.stampFile = file;
        this.stampPreview = URL.createObjectURL(file);
      }, (e) => this.$showAxiosException('上傳印花稅總繳章失敗', e));
    },
    removeStamp() {
      this.stampFile = undefined;
      this.stampPreview = '';
      this.stampID = '';
    },
    uploadLogo() {
      this.$refs.uploadLogo.click();
    },
    async changeLogoFile() {
      if (this.$refs.uploadLogo.files.length < 1) {
        return;
      }
      this.$execWithLoading(async () => {
        const file = this.$refs.uploadLogo.files[0];
        const rsp = await createLogo(file);
        this.logoID = rsp.id;
        this.logoFile = file;
        this.logoPreview = URL.createObjectURL(file);
      }, (e) => this.$showAxiosException('上傳 Logo 失敗', e));
    },
    removeLogo() {
      this.logoFile = undefined;
      this.logoPreview = '';
      this.logoID = '';
    },
    uploadSeal() {
      this.$refs.uploadSeal.click();
    },
    async changeSealFile() {
      if (this.$refs.uploadSeal.files.length < 1) {
        return;
      }
      this.$execWithLoading(async () => {
        const file = this.$refs.uploadSeal.files[0];
        const rsp = await createSeal(file);
        this.sealID = rsp.id;
        this.sealFile = file;
        this.sealPreview = URL.createObjectURL(file);
      }, (e) => this.$showAxiosException('上傳統編章失敗', e));
    },
    removeSeal() {
      this.sealFile = undefined;
      this.sealPreview = '';
      this.sealID = '';
    },
    handleClose(done) {
      done();
    },
    show() {
      this.drawer = true;
    },
    reset() {
      this.newSpaceName = '';
      this.spaces = [];
      this.origSpaces = [];
      this.name = '';
      this.origData = undefined;

      this.chargePerson = '';
      this.logoID = '';
      this.logoFile = undefined;
      this.logoPreview = '';
      this.sealID = '';
      this.sealFile = undefined;
      this.sealPreview = '';
      this.stampID = '';
      this.stampFile = undefined;
      this.stampPreview = '';
      this.positionID = '';
      this.positionFile = undefined;
      this.positionPreview = '';
    },
    close(result) {
      this.$emit('finish', result);
      this.drawer = false;
      this.reset();
    },
    cancel() {
      this.close(false);
    },
    async updateBranch() {
      await this.$execWithLoading(async () => {
        await updateBranchCustom(
          this.origData,
          this.chargePerson,
          undefined,
          this.logoID,
          this.sealID,
          this.stampID,
          this.positionID,
        );
        this.$showSuccess('設定更新');
        this.close(true);
      }, () => {
        this.$showError('設定失敗，請稍後重試');
      });
    },
    loadBranch(data) {
      this.origData = data;
      this.name = data.name;
      this.chargePerson = data.receipt_charge_person;
      if (data.receipt_logo) {
        this.logoID = data.receipt_logo.id;
        this.logoPreview = data.receipt_logo.url;
      }
      if (data.receipt_seal) {
        this.sealID = data.receipt_seal.id;
        this.sealPreview = data.receipt_seal.url;
      }
      if (data.receipt_stamp_seal) {
        this.stampID = data.receipt_stamp_seal.id;
        this.stampPreview = data.receipt_stamp_seal.url;
      }
      if (data.receipt_position_image) {
        this.positionID = data.receipt_position_image.id;
        this.positionPreview = data.receipt_position_image.url;
      }
    },
  },
  mounted() {
    this.$on('show', (data) => {
      this.reset();
      this.loadBranch(data);
      this.show();
    });
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/style/variables.scss';

.drawer {
  padding: 0 20px;
  padding-bottom: 20px;
  .op {
    .button {
      flex: 1;
    }
  }
  .photo {
    input[type=file] {
      display: none;
    }
    .preview {
      .remove-icon {
        color: $danger-color;
        width: 13px;
        height: 13px;
        border-radius: 100%;
        border: 1px solid $danger-color;
        i {
          zoom: 0.6;
        }
      }
      img {
        &.logo {
          width: 300px;
          height: 48px;
        }
        &.seal {
          width: 240px;
          height: 200px;
        }
        &.position {
          width: 240px;
        }
      }
    }
  }
}
</style>
